module.exports = __webpack_public_path__ + "resources/img/googleplay.e44bf04c.png";